import { withKeycloak } from "@react-keycloak/web";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../../localization/labels";
import KnowledgeService from "../../../../../services/KnowledgeService";
import { constants } from "../../../../../utils/Constants";
import PathUtil from "../../../../../utils/PathUtil";
import SecurityUtils from "../../../../../utils/SecurityUtils";
import { paths } from "../../../../paths";
import OccurrencesContainer from "../Occurrences";

class TopViewEntityContainer extends OccurrencesContainer {
  constructor(props) {
    super(props);

    this.knowledgeService = new KnowledgeService(this.keycloak);
  }

  loadOccurrences = () => {
    const pageInfo = { size: 5 };
    this.prepareCall(
      this.knowledgeService.getEntityTopViewOccurrence(
        pageInfo,
        this.onOccurrencesLoaded,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  occurrenceMapper = element => {
    let name = element.name;
    if (name.length > 40) {
      name = name.substr(0, 40);
      name = `${name}...`;
    }
    return {
      entityName: name,
      entityOccurence: element.occurrence,
      id: element.id
    };
  };

  getComponentTitle = () => {
    return labels.mostPopularKnowledgeItems;
  };

  xDataKey = () => "entityOccurence";

  yDataKey = () => "entityName";

  onOccurrenceClick = () => {
    return data => {
      if (
        SecurityUtils.partyHasPermissionOnEntity(data, constants.OPERATION_READ)
      ) {
        const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, data.id);
        this.changePath(itemPath, data.entityName);
      }
    };
  };
}
export default withKeycloak(withRouter(TopViewEntityContainer));
